import React from "react";

const MessFchair = () => {
  return (
    <>
      <div className="container all-section">
        <div className="row">
          <div className="col-lg-8 col-md-8">
            <div className="text-center section">
              <h3>Learn about The Everest Barber</h3>
              <img classname="divider-img" src="./divider.png" alt="divider" />
            </div>
            <div className="txt-sec">
              <p>Praesent ligula metus, suscipit vel placerat vel, suscipit eu nisl. Vestibulum hendrerit urna justo, eget congue nisi interdum a. Phasellus ornare urna vel nibh ullamcorper ultricies. Vestibulum quis ultrices augue. Donec suscipit nisl nec commodo faucibus.</p>
              <p>Aliquam nec magna iaculis, mattis elit nec, ornare enim. Phasellus at massa mollis, hendrerit nunc nec, aliquam urna. Morbi accumsan felis enim, eu molestie dolor eleifend sed. Suspendisse varius sit amet nisi ut laoreet. Curabitur sodales, enim ac consequat ultricies, odio mi blandit velit, non pulvinar lorem magna at mauris. In eleifend nibh augue. Quisque porttitor erat massa, ut fringilla dolor mollis eget. Sed sagittis feugiat justo nec aliquam. Sed varius magna nibh, lacinia gravida nunc dictum et.</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4">
            <div className="chair-man-img">
              <img src="./wrapper-img.jpg" alt="Chair-Man-Imgae"></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessFchair;
